import { render, staticRenderFns } from "./SearchAudios.vue?vue&type=template&id=6d5ef6a4&"
import script from "./SearchAudios.vue?vue&type=script&lang=js&"
export * from "./SearchAudios.vue?vue&type=script&lang=js&"
import style0 from "./SearchAudios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports